module.exports = __webpack_public_path__ + "assets/832db9965691b3b7b3632cb4aba2010d.mp3";